export default __webpack_public_path__ + "static/media/pencil.003e0c66.svg";